import { Icon } from 'types/Icon';

export const IconCheckboxChecked = ({ ...restProps }: Icon) => (
  <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...restProps}>
    <path fillRule="evenodd" clipRule="evenodd"
      d="M.48 2.87C0 3.88 0 5.2 0 7.8v4.4c0 2.61 0 3.92.48 4.93a5 5 0 0 0 2.4 2.4c1 .47 2.3.47 4.92.47h4.4c2.61 0 3.92 0 4.93-.48a5 5 0 0 0 2.4-2.4c.47-1 .47-2.3.47-4.92V7.8c0-2.61 0-3.92-.48-4.93a5 5 0 0 0-2.4-2.4C16.13 0 14.83 0 12.2 0H7.8C5.19 0 3.88 0 2.87.48a5 5 0 0 0-2.4 2.4ZM15.7 7.46a1 1 0 0 0-1.42-1.42L8 12.34l-2.3-2.3a1 1 0 1 0-1.4 1.42l3 3a1 1 0 0 0 1.4 0l7-7Z"
      fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd"
      d="M15.7 7.46a1 1 0 0 0-1.4-1.42L8 12.34l-2.3-2.3a1 1 0 1 0-1.4 1.42l3 3a1 1 0 0 0 1.4 0l7-7Z" fill="#fff" />
  </svg>
);
